var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _circle, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.9995 53.5V25C82.9995 21.134 79.8655 18 75.9995 18H23.9995C20.1335 18 16.9995 21.134 16.9995 25V67C16.9995 70.3137 19.6858 73 22.9995 73H69.4995",
    stroke: "#8999A4",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9995 26C16.9995 22.134 20.1335 19 23.9995 19H75.9995C79.8655 19 82.9995 22.134 82.9995 26V30H16.9995V26Z",
    fill: "#8999A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9995 15C30.9995 13.8954 31.8949 13 32.9995 13V13C34.1041 13 34.9995 13.8954 34.9995 15V21C34.9995 22.1046 34.1041 23 32.9995 23V23C31.8949 23 30.9995 22.1046 30.9995 21V15Z",
    fill: "#8999A4",
    stroke: "#8999A4",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4995 40C26.4995 38.8954 27.3949 38 28.4995 38H31.4995C32.6041 38 33.4995 38.8954 33.4995 40V43C33.4995 44.1046 32.6041 45 31.4995 45H28.4995C27.3949 45 26.4995 44.1046 26.4995 43V40Z",
    stroke: "#8999A4",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4995 40C53.4995 38.8954 54.3949 38 55.4995 38H58.4995C59.6041 38 60.4995 38.8954 60.4995 40V43C60.4995 44.1046 59.6041 45 58.4995 45H55.4995C54.3949 45 53.4995 44.1046 53.4995 43V40Z",
    stroke: "#8999A4",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4995 40C66.4995 38.8954 67.3949 38 68.4995 38H71.4995C72.6041 38 73.4995 38.8954 73.4995 40V43C73.4995 44.1046 72.6041 45 71.4995 45H68.4995C67.3949 45 66.4995 44.1046 66.4995 43V40Z",
    stroke: "#8999A4",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4995 55C53.4995 53.8954 54.3949 53 55.4995 53H58.4995C59.6041 53 60.4995 53.8954 60.4995 55V58C60.4995 59.1046 59.6041 60 58.4995 60H55.4995C54.3949 60 53.4995 59.1046 53.4995 58V55Z",
    fill: "#8999A4",
    stroke: "#8999A4",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4995 40C39.4995 38.8954 40.3949 38 41.4995 38H44.4995C45.6041 38 46.4995 38.8954 46.4995 40V43C46.4995 44.1046 45.6041 45 44.4995 45H41.4995C40.3949 45 39.4995 44.1046 39.4995 43V40Z",
    fill: "#8999A4",
    stroke: "#8999A4",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4995 55C39.4995 53.8954 40.3949 53 41.4995 53H44.4995C45.6041 53 46.4995 53.8954 46.4995 55V58C46.4995 59.1046 45.6041 60 44.4995 60H41.4995C40.3949 60 39.4995 59.1046 39.4995 58V55Z",
    stroke: "#8999A4",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9995 15C64.9995 13.8954 65.8949 13 66.9995 13V13C68.1041 13 68.9995 13.8954 68.9995 15V21C68.9995 22.1046 68.1041 23 66.9995 23V23C65.8949 23 64.9995 22.1046 64.9995 21V15Z",
    fill: "#8999A4",
    stroke: "#8999A4",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 81.9995,
    cy: 67,
    r: 13,
    stroke: "#8999A4",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4995 60.5C80.4995 59.6716 81.1711 59 81.9995 59V59C82.828 59 83.4995 59.6716 83.4995 60.5V66.5C83.4995 67.3284 82.828 68 81.9995 68V68C81.1711 68 80.4995 67.3284 80.4995 66.5V60.5Z",
    stroke: "#8999A4",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4995 73.5C80.4995 74.3284 81.1711 75 81.9995 75V75C82.828 75 83.4995 74.3284 83.4995 73.5V73.5C83.4995 72.6716 82.828 72 81.9995 72V72C81.1711 72 80.4995 72.6716 80.4995 73.5V73.5Z",
    stroke: "#8999A4",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0544 75.2695C12.9571 75.2695 13.689 74.5377 13.689 73.6349V73.6349C13.689 72.7322 12.9571 72.0004 12.0544 72.0004L6.63456 72.0004C5.7318 72.0004 4.99997 72.7322 4.99997 73.6349V73.6349C4.99997 74.5377 5.7318 75.2695 6.63456 75.2695L12.0544 75.2695Z",
    stroke: "#8999A4",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4224 84.4953C19.4224 85.3981 18.6905 86.1299 17.7878 86.1299V86.1299C16.885 86.1299 16.1532 85.3981 16.1532 84.4953L16.1532 79.0755C16.1532 78.1727 16.885 77.4409 17.7878 77.4409V77.4409C18.6905 77.4409 19.4224 78.1727 19.4224 79.0755L19.4224 84.4953Z",
    stroke: "#8999A4",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEvent);
export default __webpack_public_path__ + "static/media/no-event.937ecbd5a20a47b46e3dbc89b3093f61.svg";
export { ForwardRef as ReactComponent };